import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CategoryList from "./CategoryList";
import BlogList from "./BlogList";
import { getBlogs } from "../../redux/blogSlice";
import { FiLoader } from "react-icons/fi";

const CATEGORIES = [
  { key: "allArticles", label: "All Articles" },
  { key: "mentalHealth", label: "Mental Health" },
  { key: "therapy", label: "Therapy" },
  { key: "relationships", label: "Relationships" },
  { key: "personalGrowth", label: "Personal Growth" },
  { key: "parentingFamily", label: "Parenting & Family" },
  { key: "cultureIdentity", label: "Culture & Identity" },
  { key: "onlineTherapy", label: "Online Therapy" },
  { key: "selfCareWellbeing", label: "Self-Care & Wellbeing" },
  { key: "forTherapists", label: "For Therapists" },
];

export default function BlogPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { blogs, loading } = useSelector((state) => state.blogs);
  const [selectedCategory, setSelectedCategory] = useState("allArticles");

  useEffect(() => {
    dispatch(getBlogs({ limit: 100, status: "published" }));
  }, [dispatch]);

  const categories = CATEGORIES.map((c) => ({ ...c, label: t(c.key, { defaultValue: c.label }) }));

  const filteredBlogs =
    selectedCategory === "allArticles"
      ? blogs
      : blogs.filter((b) => b.category === selectedCategory);

  const normalizedBlogs = filteredBlogs.map((b) => ({
    ...b,
    id: b._id || b.id,
    title: b.title || "",
    destination: b.description || "",
    coverImage: b.image || "",
    publishDate: b.createdAt,
  }));

  return (
    <div className="flex flex-col md:flex-row max-w-7xl mx-auto mt-24 md:mt-36 px-4 gap-6 mb-12">
      {/* Category sidebar */}
      <div className="w-full md:w-1/4 md:sticky md:top-20 md:h-[calc(100vh-80px)] md:overflow-auto border-b md:border-b-0 md:border-r border-gray-200 p-4 rounded-lg pb-2 md:pb-4">
        <CategoryList
          categories={categories.map((c) => c.label)}
          selectedCategory={categories.find((c) => c.key === selectedCategory)?.label}
          onSelectCategory={(label) =>
            setSelectedCategory(
              categories.find((c) => c.label === label)?.key || "allArticles"
            )
          }
        />
      </div>

      {/* Blog list */}
      <div className="flex-1 p-4">
        {loading ? (
          <div className="flex items-center justify-center py-20 gap-3 text-gray-400">
            <FiLoader className="w-6 h-6 animate-spin" />
            <span>Loading articles...</span>
          </div>
        ) : (
          <BlogList blogs={normalizedBlogs} />
        )}
      </div>
    </div>
  );
}
